import {
  ArcadeStoreContext,
  ArcadeStoreContextType,
} from '@src/providers/store';
import { useContext } from 'react';

export const useArcadeStoreState = (): ArcadeStoreContextType => {
  const ctx = useContext(ArcadeStoreContext);

  return {
    partBalance: ctx?.partBalance,
    partBalancePending: ctx?.partBalancePending,
    partBalanceTotal: ctx?.partBalanceTotal,
    partRecords: ctx?.partRecords,
    purchasePartBalance: ctx?.purchasePartBalance,
    descendingPartRecords: ctx?.descendingPartRecords,
    pendingCount: ctx?.pendingCount,
    unspentCount: ctx?.unspentCount,
    totalCount: ctx?.totalCount,
    account: ctx?.account,
    connect: ctx?.connect,
    connectError: ctx?.connectError,
    connectLoading: ctx?.connectLoading,
    isConnected: ctx?.isConnected,
    isPuzzleWalletWebview: ctx?.isPuzzleWalletWebview,
    isPro: ctx?.isPro,
    countryCode: ctx?.countryCode,
    defaultCountryCode: ctx?.defaultCountryCode,
  };
};
